import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { map, tap } from 'rxjs';

export const notAuthGuard: CanActivateFn = (route, state) => {
    const _authService = inject(AuthService);
    const _router = inject(Router);
  
    
    return _authService.isLoggedIn.pipe(
      tap(isLoggedIn => {
        if (isLoggedIn) {
          _router.navigateByUrl('/dashboard', { replaceUrl: true });
        }
      }),
      map(isLoggedIn => {
        const shouldAllow = !isLoggedIn;
        return shouldAllow;
      })
    );
};
